module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "证件照片",
      "value": _vm.formData.pic.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 1,
      "name": 'pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传符合正式规范的2寸证件照，蓝底、白底、灰底均可")]), _vm._v(" "), _c('van-notice-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.status == 1),
      expression: "formData.status == 1"
    }],
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": "证件照正在审核中，人工审核中预计7天，审核通过后，可以再次下载证书哦~"
    }
  }), _vm._v(" "), _c('van-notice-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.status == 3),
      expression: "formData.status == 3"
    }],
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": _vm.formData.admin_note
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.pic.length > 0 ? '修改' : '保存') + "\n        ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39a10b75","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/cert/CertPersonPhoto.vue
// module id = 2328
// module chunks = 0